import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import "./style.scss";

const DeviceIcon = () => (
	<svg
		width="40"
		height="40"
		viewBox="0 0 40 40"
		fill="none"
		xmlns="http://www.w3.org/2000/svg">
		<path
			d="M0 10C0 4.47715 4.47715 0 10 0H30C35.5228 0 40 4.47715 40 10V30C40 35.5228 35.5228 40 30 40H10C4.47715 40 0 35.5228 0 30V10Z"
			fill="#00D1FF"
			fillOpacity="0.1"
		/>
		<path
			d="M12.5 23.3333C12.5 21.4924 13.9924 20 15.8333 20H24.1667C26.0076 20 27.5 21.4924 27.5 23.3333V24.1667C27.5 25.0871 26.7538 25.8333 25.8333 25.8333H14.1667C13.2462 25.8333 12.5 25.0871 12.5 24.1667V23.3333Z"
			stroke="#00D1FF"
			strokeWidth="1.66667"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M15 20V18.3333C15 16.0321 16.8655 14.1667 19.1667 14.1667H20.8333C23.1345 14.1667 25 16.0321 25 18.3333V20"
			stroke="#00D1FF"
			strokeWidth="1.66667"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<circle cx="17.5" cy="23" r="1.25" fill="#00D1FF" />
		<circle cx="22.5" cy="23" r="1.25" fill="#00D1FF" />
	</svg>
);

const HomeIcon = () => (
	<svg
		width="20"
		height="20"
		viewBox="0 0 20 20"
		fill="none"
		xmlns="http://www.w3.org/2000/svg">
		<path
			d="M12.5 17.5V10.8333C12.5 10.6123 12.4122 10.4004 12.2559 10.2441C12.0996 10.0878 11.8877 10 11.6667 10H8.33333C8.11232 10 7.90036 10.0878 7.74408 10.2441C7.5878 10.4004 7.5 10.6123 7.5 10.8333V17.5"
			stroke="#000"
			strokeWidth="1.66667"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M2.5 8.33335C2.49994 8.0909 2.55278 7.85137 2.65482 7.63144C2.75687 7.41152 2.90566 7.21651 3.09083 7.06001L8.92417 2.06085C9.22499 1.8066 9.60613 1.66711 10 1.66711C10.3939 1.66711 10.775 1.8066 11.0758 2.06085L16.9092 7.06001C17.0943 7.21651 17.2431 7.41152 17.3452 7.63144C17.4472 7.85137 17.5001 8.0909 17.5 8.33335V15.8333C17.5 16.2754 17.3244 16.6993 17.0118 17.0119C16.6993 17.3244 16.2754 17.5 15.8333 17.5H4.16667C3.72464 17.5 3.30072 17.3244 2.98816 17.0119C2.67559 16.6993 2.5 16.2754 2.5 15.8333V8.33335Z"
			stroke="#000"
			strokeWidth="1.66667"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
);

const FailedBooking = () => {
	const { t } = useTranslation();
	const history = useHistory();

	return (
		<div className="home">
			<div className="confirm-booking">
				<div className="container">
					<div className="circle2"></div>
					<p className="page-title" style={{ color: "#ff000080" }}>
						{t("Booking Failed!")}
					</p>
					<p className="description">
						{t("Get ready for an amazing VR experience")}
					</p>

					<div className="confirm-buttons">
						<button className="view-bookings" onClick={() => history.push("/")}>
							<HomeIcon />
							{t("Back to Home")}
						</button>
						<button
							className="back-games"
							onClick={() => history.push("/games")}>
							<DeviceIcon />
							{t("Back to Games")}
						</button>
					</div>
				</div>
			</div>
		</div>
	);
};
export default FailedBooking;
